import { ReactNode } from 'react'
import { connect } from 'react-redux'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import { STEP_2_VALIDATION_URL } from '../../costants'

import Contractor from '../../components/people/contractor/Contractor'
import SiNo, { SiNoType, getBoolean, getSiNoValue } from '../../components/siNo/SiNo'
import { getPrivacyForSubmit, isValidPrivacy } from '../../components/privacy/BasicPrivacy'

import LoginRegister from '../../components/login/LoginRegister'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import Input from '../../libs/ui/inputs/Input'
import Select from '../../libs/ui/inputs/Select'
import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { authFetch } from '../../libs/cookie/Cookie'

import * as StringValidation from '../../libs/validation/stringRegex'
import { isNotValiDataNascita, isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'
import { numberValidation, objectsNamesValidation } from '../../libs/validation/remoteValidationAbstract'
import { CompleteValidationError } from '../../libs/validation/completeValidationError'

import { getTipiAnimaili } from '../../libs/initialization/remoteInits'


import { HouseholderPageProps, HouseholderPageState, householderPageInitialState, householderUpdate } from './HouseholderPageSilce'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'


class HouseholderPage extends BasePage<HouseholderPageProps, HouseholderPageState> {

    constructor (props: any) {
        super(props)

        this.state = {
            ...householderPageInitialState,
            ...props
        }

        // metodi ereditati
        this.getInitialState = this.getInitialState.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        // metodi specifici del preventivatore
        this.updateFamiliari = this.updateFamiliari.bind(this)
        this.updateAnimali = this.updateAnimali.bind(this)
        this.updateAnimali_pericolosi = this.updateAnimali_pericolosi.bind(this)
        this.updateTipo_animali = this.updateTipo_animali.bind(this)
        this.updateAltri_animali = this.updateAltri_animali.bind(this)

        this.updateTipiAnimali = this.updateTipiAnimali.bind(this)

        this.isValidDate = this.isValidDate.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.tipi === undefined) {
            getTipiAnimaili (this.updateTipiAnimali, this.manageExpiredSessions)
        }
    }

    render () : ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="householder_form">
                                <Pagination
                                    maxPagges={2}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={true}
                                            isOnlyGiuridica={false}
                                        />
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={true}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <div className='col-12'>
                                            <Input 
                                                id='numero_familiari' name='numero_familiari'
                                                label='Componenti del nucleo famigliare'
                                                value={this.state.familiari?.toString()}
                                                type='number'
                                                step='1'
                                                min='1'
                                                regexp={StringValidation.NUMBER_PATTERN}
                                                remoteValidation={numberValidation}
                                                errorDisplayMsg={'Valore non valido'}
                                                callback={this.updateFamiliari}
                                                error={this.state.familiariError}
                                            />
                                            

                                            <SiNo 
                                                id='animali' name="animali"
                                                label='Hai animali domestici?'
                                                value={ getSiNoValue( this.state.animali ) }
                                                callback={this.updateAnimali}
                                                error={this.state.animaliError}
                                            />

                                            { this.state.animali &&
                                                <>
                                                    <SiNo 
                                                        id='animali_pericolosi' name="animali_pericolosi"
                                                        label='Hai animali domestici pericolosi?'
                                                        value={ getSiNoValue( this.state.animali_pericolosi ) }
                                                        callback={this.updateAnimali_pericolosi}
                                                        error={this.state.animali_pericolosiError}
                                                    />

                                                    <Select
                                                        id='tipo_animali' name='tipo_animali'
                                                        label='Indica il tuo animale' 
                                                        value={this.state.tipo_animali}
                                                        options={this.state.tipi}
                                                        callback={this.updateTipo_animali}
                                                        error={this.state.tipo_animaliError}
                                                    />

                                                    { this.state.tipo_animali === 'altro' &&
                                                        <>
                                                            <Input 
                                                                id='altri_animali' name='altri_animali'
                                                                label='Indica la tipologia del tuo animale o il numero se sono più di uno' 
                                                                value={this.state.altri_animali}
                                                                type='text'
                                                                maxLength={100}
                                                                callback={this.updateAltri_animali}
                                                                regexp={StringValidation.OBJECTS_NAMES_PATTERN}
                                                                errorDisplayMsg='Valore non valido'
                                                                remoteValidation={objectsNamesValidation}
                                                                error={this.state.altri_animaliError}
                                                            />
                                                        </>
                                                    }
                                                </>
                                            }
                                        </div>
                                    
                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />
                                    </SinglePage>
                                </Pagination>
                            </form>

                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    // -- comuni
    getInitialState() {
        return householderPageInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
        ])
        .then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }

            return {
                errorString: e,
                pageError: p
            }
        })
        .catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }
    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        const superErrors = super.printError(errorString, waith, pageError)

        if (superErrors?.globalError !== undefined) {
            this.setState( superErrors )
        } else {
            let familiariErro = undefined
            let animaliErro = undefined
            let animali_pericolosiErro = undefined
            let tipo_animaliErro = undefined
            let altri_animaliErro = undefined

            let noMotorPrivacyErro = undefined
            let global = undefined

            if (errorString === 'FAMILIARI' ) {
                familiariErro = 'Valore non valido'
                global = 'Indicare il numero di familiari'
            }
            else if (errorString === 'ANIMALI' ) {
                animaliErro = 'Valore non valido'
                global = 'Indicare se si possiedono degli animali'
            }
            else if (errorString === 'ANIMALI_PERICOLOSI' ) {
                animali_pericolosiErro = 'Valore non valido'
                global = 'Indicare se si possiedono degli animali pericolosi'
            }
            else if (errorString === 'TIPO_ANIMALI' ) {
                tipo_animaliErro = 'Valore non valido'
                global = 'Indicare il tipo di animale posseduto'
            }
            else if (errorString === 'ALTRI_ANIMALI' ) {
                altri_animaliErro = 'Valore non valido'
                global = 'Specificare il tipo di animali (e il numero) posseduti'
            }
            else if ( errorString === 'PRIVACY' ) {
                noMotorPrivacyErro = 'Selezionare i campi obbligatori'
                global = noMotorPrivacyErro
            }
            else {
                global = errorString
            }

            this.setState ({
                waith: waith,
                actualPage: pageError ?? this.state.actualPage,

                familiariError: familiariErro,
                animaliError: animaliErro,
                animali_pericolosiError: animali_pericolosiErro,
                tipo_animaliError: tipo_animaliErro,
                altri_animaliError: altri_animaliErro,
                
                noMotorPrivacyError: noMotorPrivacyErro,

                globalError: global,
            })
        }

    }

    getSpecificDataForSubmit () {
        const isAltro = this.state.tipo_animali === 'altro'

        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            nascita: this.state.contractor?.data_nascita !== undefined ? this.state.contractor.data_nascita : null,
            familiari: this.state.familiari !== undefined ? this.state.familiari : null,
            animali: this.state.animali !== undefined ? this.state.animali : null,
            animali_pericolosi: this.state.animali_pericolosi !== undefined ? this.state.animali_pericolosi : null,
            tipo_animali: this.state.tipo_animali !== undefined ? this.state.tipo_animali : null,
            altri_animali: (isAltro && this.state.altri_animali !== undefined) 
                ? this.state.altri_animali 
                : null,
        }
    }

    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    householderUpdate (this.state)
                )
            }
        )
    }

    // -- solo del preventivatore

    private updateTipiAnimali (tipi: any) {
        this.setState ({
            tipi: tipi
        })
    }

    
    private updateFamiliari (val: number | undefined) {
        this.saveStateAndRedux ({
            familiari: val,
            familiariError: undefined
        })
    }
    private updateAnimali (val: SiNoType) {
        this.saveStateAndRedux ({
            animali: getBoolean( val ),
            animaliError: undefined
        })
    }
    private updateAnimali_pericolosi (val: SiNoType) {
        this.saveStateAndRedux ({
            animali_pericolosi: getBoolean( val ),
            animali_pericolosiError: undefined
        })
    }
    private updateTipo_animali (val: string | undefined) {
        const clear = val !== 'altro'

        this.saveStateAndRedux ({
            tipo_animali: val,
            tipo_animaliError: undefined,
            altri_animali: (clear) ? undefined : this.state.altri_animali
        })
    }
    private updateAltri_animali (val: string | undefined) {
        this.saveStateAndRedux ({
            altri_animali: val,
            altri_animaliError: undefined
        })
    }

    private isValidDate (d: string | undefined) {
        if (d === undefined)
            return true

        return !isNotValiDataNascita( d )
    }

    private async step2Validation () {
        let error = undefined

        if (this.state.altriSinistri === undefined) {
            error = 'SINISTRI'
        }
        else if (this.state.polizzaAttiva === undefined) {
            error = 'POLIZZA'
        }
        else if (
            this.state.polizzaAttiva === true && 
            isNotValidScadenzaPolizza(this.state.scadenzaPolizza)
        ) {
            error = 'SCADENZA_POLIZZA'
        }
        if ( this.state.familiari === undefined ) {
            error = 'FAMILIARI'
        }
        else if ( this.state.animali === undefined ) {
            error = 'ANIMALI'
        }
        else if ( this.state.animali && this.state.animali_pericolosi === undefined ) {
            error = 'ANIMALI_PERICOLOSI'
        }
        else if ( this.state.animali && this.state.tipo_animali === undefined ) {
            error = 'TIPO_ANIMALI'
        }
        else if ( 
            this.state.animali && 
            this.state.tipo_animali === 'altro' && 
            this.state.altri_animali === undefined 
        ) {
            error = 'ALTRI_ANIMALI'
        }
        else if (!isValidPrivacy(this.state.noMotorPrivacy, this.state.user !== undefined)) {
            error = 'PRIVACY'
        }
        else {
            await authFetch (
                STEP_2_VALIDATION_URL,
                {
                    method: "post",
                    body: JSON.stringify({
                        specificData: this.getSpecificDataForSubmit(),
                        privacy: getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
                        isLogged: this.state.expiredSessionError === false ? this.state.user !== undefined : false
                    })
                },
                this.manageExpiredSessions,
            ).then ( jsonObj => {
                if (jsonObj.status > 200) {
                    error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
                }
            }).catch( error => {
                error = CONNECTION_ERROR
            })
        }

        this.printError(error)

        return error
    }
}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    familiari: state.familiari,
    animali: state.animali,
    animali_pericolosi: state.animali_pericolosi,
    tipo_animali: state.tipo_animali,
    altri_animali: state.altri_animali,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user
  }
}

export default connect(mapState) (HouseholderPage)